import * as XLSX from "xlsx";

/**
 * Downloads an XLSX file with the provided worksheet data, filename, and column widths.
 *
 * @param {any[][]} worksheetData A 2D array representing the data for the worksheet.
 * @param {string} filename The name of the file to be downloaded, including the extension (e.g., "file.xlsx").
 * @param {number[]} columnWidths An array of numbers specifying the column widths in characters.
 */
export function downloadXLSX(worksheetData, filename, columnWidths) {
    const workbook = XLSX.utils.book_new();

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    worksheet["!cols"] = columnWidths?.map((width) => ({ wch: width }));

    XLSX.utils.book_append_sheet(workbook, worksheet, "Responses");

    XLSX.writeFile(workbook, filename);
}
